/* eslint-disable @next/next/no-img-element */

// components
import { Container } from 'components/Grid';
import { VideoPlayer } from '@/containers-m/VideoPlayer';

// styles
import {
  SectionWrapper,
  TitleWrapper,
  AwardsBadges,
  BadgeContainer,
  Badge,
  CTAWrapper,
  Title,
  IntroText,
  MediaWrapper,
  LogoWrapper,
} from './LogoImageCTA.styles';

//components
import { MirandaSecondaryButton } from '@/components/Button/BaseButton';

//logos
import ShipperGuideTMS from '@/public/images/logos/logo-shipperguidetms-black.svg';

export function LogoImageCTA() {
  const video_settings = {
    youtube: 'https://www.youtube.com/watch?v=C3Me6bWCWkk?rel=0',
    thumb: '/images/home/thumb/bg-sg4pl.webp',
    preview: '/videos/home/bg_sg_tracking.webm',
  };

  return (
    <SectionWrapper>
      <Container>
        <TitleWrapper>
          <LogoWrapper>
            <ShipperGuideTMS width="442" height="49" />
          </LogoWrapper>

          <Title>Everything you need in a TMS, with none of the fluff.</Title>
          <IntroText>
            Loadsmart’s transportation management system, ShipperGuide TMS, is
            an award-winning solution built for busy teams. Fast ROI with
            intuitive, modern interface that means fast onboarding and
            technology your logistics department will actually use.
          </IntroText>

          <AwardsBadges>
            <BadgeContainer>
              <Badge
                width="92"
                height="106"
                src="/images/awards/g2-logos-2025/FreightManagement_EasiestSetup_Mid-Market.svg"
                alt="Easiest Setup Mid-Market"
              />
            </BadgeContainer>
            <BadgeContainer>
              <Badge
                width="92"
                height="106"
                src="/images/awards/g2-logos-2025/TransportationManagementSystemsTMS_BestSupport.svg"
                alt="Best Support"
              />
            </BadgeContainer>
            <BadgeContainer>
              <Badge
                width="92"
                height="106"
                src="/images/awards/g2-logos-2025/TransportationManagementSystemsTMS_EasiestToDoBusinessWith.svg"
                alt="Easiest to do Business With"
              />
            </BadgeContainer>
            <BadgeContainer>
              <Badge
                width="92"
                height="106"
                src="/images/awards/g2-logos-2025/TransportationManagementSystemsTMS_Leader.svg"
                alt="Grid Leader"
              />
            </BadgeContainer>
          </AwardsBadges>
        </TitleWrapper>
        <MediaWrapper>
          <VideoPlayer content={video_settings} />
        </MediaWrapper>
        <CTAWrapper>
          <MirandaSecondaryButton
            as="a"
            href="https://shipperguide.com/?utm_source=loadsmart-website"
          >
            Know More About ShipperGuide TMS
          </MirandaSecondaryButton>
        </CTAWrapper>
      </Container>
    </SectionWrapper>
  );
}
